import React from 'react'
import { Column } from 'styled/alignment/Column'
import Text from './Text'
import styled from 'styled-components'
import Divider from './Divider'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'
import Icon from './Icon'
import { StyledRouteLink } from 'styled/UI/StyledButton'
import { Row } from 'styled/alignment/Row'
import { CreditCard, HelpCircle, Mail, MessageCircle, Shield } from 'lucide-react'
import LinkPage from './LinkPage'
import CONTACT from 'constants/contact'

export default function FooterCheckout() {
    const flags = [
        {
            path: '/assets/images/elo.png',
            alt: 'Elo'
        },
        {
            path: '/assets/images/visa.png',
            alt: 'Visa'
        },
        {
            path: '/assets/images/master-card.png',
            alt: 'MasterCard'
        },

        {
            path: '/assets/images/discover.png',
            alt: 'Discover'
        },
        {
            path: '/assets/images/dinners.png',
            alt: 'Dinners'
        },
        {
            path: '/assets/images/aura.png',
            alt: 'Aura'
        },
        {
            path: '/assets/images/jcb.png',
            alt: 'JCB'
        },
        {
            path: '/assets/images/amex.png',
            alt: 'Ammex'
        },
        {
            path: '/assets/images/pix.png',
            alt: 'Pix'
        },


    ]

    const security = [
        {
            path: '/assets/images/googsafebrowsing.png',
            alt: 'Google Safe Browsing'
        },
        // {
        //     path: '/assets/images/pci.png',
        //     alt: 'PCI'
        // },
    ]


    return (
        <ContainerFooter>
            <ContentFooter>
                {/* <Divider marginTop={'20px'} color={colors.primaryDashboard} opacity={0.3} /> */}
                <MainContent>

                    <LineItens>
                        <Row>
                            <CreditCard color={colors.occasionalPurple} size={20} />
                            <Text name='highlight' color={colors.occasionalPurple} marginLeft={'8px'} marginBottom={'10px'}>
                                Métodos de pagamento
                            </Text>
                        </Row>
                        <ContainerIcon>

                            {flags.map((el) => (
                                <ContentIcon
                                    key={el.alt}
                                >
                                    <img src={el.path} alt={el.alt} />
                                </ContentIcon>
                            ))}

                        </ContainerIcon>

                    </LineItens>
                    {/* 
                    <DividerMobile>
                        <Divider color={colors.primaryDashboard} opacity={0.3} />
                    </DividerMobile> */}

                    <LineItens center>
                        <Row>
                            <Shield color={colors.occasionalPurple} size={20} />

                            <Text name='highlight' color={colors.occasionalPurple} marginLeft={'8px'} marginBottom={'10px'}>
                                Compre com segurança
                            </Text>
                        </Row>
                        <Content>
                            <Text>As informações sensíveis são protegidas por criptografia e não são armazenadas em nossos servidores.</Text>

                            <Text>
                                Navegação segura garantida. Monitorado com base no &nbsp;
                                <LinkButton
                                    target='_blank'
                                    href={`https://transparencyreport.google.com/safe-browsing/search?url=${import.meta.env.VITE_CLIENT_URL}`}
                                >
                                    Google Safe Browsing
                                </LinkButton>.
                            </Text>
                            {/* <ContainerIcon>
                                {
                                    security.map((el) => (
                                        <ContentIcon not>
                                            <img src={el.path} alt={el.alt} />
                                        </ContentIcon>
                                    ))
                                }
                            </ContainerIcon> */}
                        </Content>

                    </LineItens>

                    {/* 
                    <DividerMobile>
                        <Divider color={colors.primaryDashboard} opacity={0.3} />
                    </DividerMobile> */}

                    <LineItens last>
                        <Row>
                            <HelpCircle color={colors.occasionalPurple} size={20} />

                            <Text name='highlight' color={colors.occasionalPurple} marginLeft={'8px'} marginBottom={'10px'} marginBottom={'10px'}>
                                Precisa de ajuda?
                            </Text>
                        </Row>
                        <Content>
                            <Text>
                                Selecione um meio para entrar em contato conosco e tirar suas dúvidas.

                            </Text>
                            <Row marginTop='10px'>
                                <ContactButton
                                    href="https://wa.me/5391665255"
                                    target="_blank"
                                    color="#25D366"
                                >
                                    <MessageCircle size={15} />
                                    <Text name='small' color={colors.neutralLight} paddingBottom={0} marginLeft={'6px'}>WhatsApp</Text>
                                </ContactButton>

                                <ContactButton
                                    href={`mailto:${CONTACT.email}`}
                                    target="_blank"
                                    color="#3B82F6"
                                >
                                    {/* <IconWrapper>
                                        <Icon name="mail" color="#3B82F6" />
                                    </IconWrapper> */}
                                    <Mail size={15} />
                                    <Text name='small' color={colors.neutralLight} paddingBottom={0} marginLeft={'6px'}>E-mail</Text>
                                </ContactButton>
                            </Row>


                        </Content>
                    </LineItens>
                </MainContent>
            </ContentFooter>
        </ContainerFooter>
    )
}

const ContainerFooter = styled(Column)`
    width: 100%;
    padding: 20px 0;
    margin-top: -50px;
    /* background: red; */
    @media screen  and (min-width: ${breakpoints.lg}) {
        padding: 0;
        margin-bottom: 30px;
        margin-top: 30px;
        justify-content: space-between;
    }
    
    /* @media screen  and (min-width: ${breakpoints.xl}) {
        padding: 0px 4%;
        margin-bottom: 30px;
        margin-top: 0;
    } */
`;

const ContentFooter = styled(Column)`
    width: 100%;
    display: flex;
    flex-direction: column;
    /* margin-bottom: 20px; */
    
    @media screen and (min-width: 690px) {
        display: flex;
        flex-direction: column;
    }
    @media screen and (min-width: ${breakpoints.lg}) {
        justify-content: space-between;
        padding: 10px 14px;
    }
`;


const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 4%;
    
    @media screen and (min-width: ${breakpoints.lg}) {
        padding: 0;
        flex-direction: row;
        justify-content: space-between;
    }

`;

const ContentIcon = styled.div`
    border-radius: 4px;
    width: auto;
    display: flex;
    flex-direction: row;
    margin: 5px 0;
    
    & > img {
        width: auto;
        height: 32px;
        padding: 4px;
    }

    ${({ not }) => not && `
        margin-right: 10px;
        & > img {
            height: 52px;
        }
    `}

    ${({ faq }) => faq && `
            margin-top: 20px;
            background: unset;
        & > svg {
            height: 50px;
        }
    `}
    
`;


const LineItens = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 10px;
    background: ${colors.neutralLight};
    box-shadow: 0 0 4px #ccc;
    padding: 30px;
    border-radius: 8px;
    margin-top: 20px;
    border: 1px solid ${colors.neutralDark};
    
    @media screen and (min-width: ${breakpoints.lg}) {
        width: 32%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        /* border-right: 1px solid #cccc; */
        margin-right: 2%;
        margin-top: -14px;

        &:last-child {
            margin-right: 0 !important;
        }


        /* ${({ last }) => last && `
            border-right: none;
            padding: 10px 0px 0px 25px;
        `}
        ${({ center }) => center && `
            padding: 10px 25px 0px 25px;
        `} */
    }
`;

const ContainerIcon = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    text-align: left;

    ${({ center }) => center && `
        display: flex;
        justify-content: space-around;
       
    `}
`;

const Content = styled.div`
   
    width: 100%;
    & > p {
        text-align: left;
    }

    @media screen and (${breakpoints.lg}) {
        max-width: 320px;
    }
`;

const DividerMobile = styled.div`
    display: flex;
    @media screen and (${breakpoints.lg}) {
        display: none;
    }
`;

const LinkTo = styled(StyledRouteLink)`
    cursor: pointer;
    height: 50px;
`;

const ContactButton = styled.a`
    display: flex;
    align-items: center;
    background-color: ${({ color }) => color};
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    text-decoration: none;
    padding: 8px 14px;
    border-radius: 9999px;
    margin-right: 10px;
    transition: background-color 0.3s ease;
    width: auto;

    & > span {
        margin-left: 8px;
    }

    &:hover {
        opacity: 0.9;
    }
`;

const IconWrapper = styled.div`
    background-color: #fff;
    border-radius: 9999px;
    width: 20px;
    height: 20px;
    padding: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const LinkButton = styled.a`
    color: ${colors.primary};
    text-decoration: underline;
`;